import { render, staticRenderFns } from "./tourist-source.vue?vue&type=template&id=a33942c4&scoped=true"
import script from "./tourist-source.vue?vue&type=script&lang=js"
export * from "./tourist-source.vue?vue&type=script&lang=js"
import style0 from "./tourist-source.vue?vue&type=style&index=0&id=a33942c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_d79148f6156699cf80ef22aa45ce0a5c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33942c4",
  null
  
)

export default component.exports